import { type CardNode, type CardType, detectCardType } from './types';

type MdNode = {
  [key: string]: unknown;
  children?: MdNode[];
  type?: string;
  value?: string;
};

function extractTextContent(node: MdNode): string {
  if (node.type === 'text') {
    return typeof node.value === 'string' ? node.value : '';
  }

  if (!Array.isArray(node.children)) {
    return '';
  }

  return node.children.map(extractTextContent).join(' ');
}

function createCardNode(blockquote: MdNode, cardType: CardType): CardNode {
  return {
    type: 'card',
    cardType,
    children: blockquote.children || [],
    data: {
      hName: 'div',
      hProperties: {
        className: ['card-block', `card-${cardType}`],
        'data-card-type': cardType,
      },
    },
  };
}

function transformChildren(parent: MdNode): MdNode {
  if (!Array.isArray(parent.children)) {
    return parent;
  }

  const children = parent.children.map((child) => {
    if (child.type === 'blockquote') {
      const cardType = detectCardType(extractTextContent(child));
      if (cardType) {
        return createCardNode(child, cardType) as unknown as MdNode;
      }
    }

    return transformChildren(child);
  });

  return { ...parent, children };
}

export function remarkSingleCard() {
  return (tree: MdNode) => transformChildren(tree);
}

export default remarkSingleCard;
